import React from 'react';
import PageDocumentTitle from '../PageDocumentTitle';
import PageHeader from '../PageHeader';
import PageRoot from '../PageRoot';
import PageShell from '../PageShell';
import PageState from '../PageState';

export default function StandardPageLayout({
    documentTitle,
    title,
    headerMeta,
    banners,
    loading,
    error,
    empty,
    loadingMessage,
    filters,
    children,
}) {
    return (
        <PageRoot variant="standard">
            <PageDocumentTitle title={documentTitle} />
            <PageShell variant="standard">
                <PageHeader title={title} headerMeta={headerMeta} />
                {banners}
                {filters}
                <PageState
                    loading={loading}
                    error={error}
                    empty={empty}
                    loadingMessage={loadingMessage}
                >
                    {children}
                </PageState>
            </PageShell>
        </PageRoot>
    );
}
